import { useLottie } from "lottie-react";
import * as animationData from '../../../assets/lotties/playing.json'


function Badge({ text, type, icon, size, isPlaying, isLoading, cypress}) {
  const options = {
    animationData: animationData,
    loop: true
  }

  const { View } = useLottie(options);
  let classNames = ''
  if (type === 'error') classNames="bg-backgroundError text-error"
  if (type === 'danger') classNames="bg-error text-white"
  else if (type === 'waiting') classNames="bg-secondary text-white"
  else if (type === 'warning') classNames="bg-warning text-white"
  else if (type === 'success') classNames="bg-success text-white"
  else if (type === 'secondary-success') classNames="bg-backgroundSuccess text-success"
  else if (type === 'gray') classNames="bg-greyLight5 text-white"
  else if (type === 'greyLight4') classNames="bg-greyLight4 text-white"
  else classNames="bg-backgroundSuccess text-success"
  return (
    <div className={'relative inline-flex group rounded-4 font-semibold text-sm ' + classNames + (size === "small" ? ' p-4 px-8 ' : ' p-8')}
    data-cy={'badge-'+cypress}>
      {icon && <i className={icon + ' text-[18px] leading-[18px] mr-8'}/>}
      {isPlaying ? <div className='w-[18px] h-[18px] overflow-hidden flex items-center justify-center relative  mr-8'>
        <div className='w-[40px] h-[40px] absolute top-50% left-50% '>{View}</div>
      </div> : null}
      {isLoading ? <i className='icon-spinner animate-spin-pulse  w-[18px] h-[18px] overflow-hidden flex items-center justify-center relative  mr-8'>
      </i> : null}
      <span className='block leading-[18px] '>{text}</span>
    </div>
  )
}

export default Badge
